import { styled } from '@mui/material';

export const FormContainerStyled = styled('section')(({ theme }) => ({
  width: 640,
  margin: theme.spacing(4, 'auto'),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));
